import React from 'react';
import { Clock, PauseCircle } from 'lucide-react';
import { useSecondScreenData } from '../../../contexts/SecondScreenContext';
import type { WidgetProps } from '../../../types/second-screen.types';

function formatSimTime(ms: number): string {
  const totalMinutes = Math.floor(ms / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `T+${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}

const IncidentClockWidget: React.FC<WidgetProps> = () => {
  const { state, theme } = useSecondScreenData();
  const isDark = theme === 'dark';
  const tabletop = state?.tabletop;

  if (!tabletop) {
    return (
      <div className={`flex items-center justify-center h-full text-sm ${isDark ? 'text-white/30' : 'text-slate-400'}`}>
        No active exercise
      </div>
    );
  }

  const nextDeadline = tabletop.deadlines[0];

  return (
    <div className="flex flex-col items-center justify-center h-full gap-2 px-3">
      <div className="flex items-center gap-2">
        {tabletop.held && <PauseCircle size={20} className="text-amber-400" />}
        <div
          className={`font-mono text-3xl font-bold tracking-wider ${isDark ? 'text-white' : 'text-slate-900'}`}
          style={isDark ? { textShadow: '0 0 20px rgba(0, 199, 196, 0.3)' } : {}}
        >
          {formatSimTime(tabletop.simTimeMs)}
        </div>
      </div>
      <div className={`text-sm font-medium ${isDark ? 'text-white/40' : 'text-slate-400'}`}>
        {tabletop.held ? 'HELD — ' : ''}{tabletop.actLabel}
      </div>
      {nextDeadline && (
        <div className={`flex items-center gap-1.5 text-sm ${isDark ? 'text-amber-300/80' : 'text-amber-600'}`}>
          <Clock size={11} />
          Next: {nextDeadline.label} at {formatSimTime(nextDeadline.atSimMs)}
        </div>
      )}
    </div>
  );
};

export default IncidentClockWidget;
